<div class="pricelist-selecetion-blk mb-5 mb-sm-0 mx-3 my-3">
  <ul class="list-inline">
    <li class="list-inline-item">
      <div class="form-item-label">
        <h4 class="selection-label products-label">
          {{ 'pages.placeholders.SalesRepsDistributorPricelist' | translate }}
        </h4>
      </div>
    </li>
    <li class="list-inline-item">
      <div class="form-item-input search-dropdown">
        <mat-form-field appearance="outline">
          <mat-select
            [(ngModel)]="PricelistSelected"
            name="pricelist"
            (selectionChange)="onPricelistSelect($event)"
          >
            <mat-option
              *ngFor="let Pricelist of Pricelists"
              [value]="Pricelist"
            >
              {{ Pricelist }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </li>
  </ul>
</div>
<ng-container *ngIf="isPricelistSelected">
  <ng-container *ngTemplateOutlet="pricelistGrid"></ng-container>
</ng-container>

<ng-template #pricelistGrid>
  <div class="pricelist-grid-showcase search-holder">
    <ul class="list-inline grid-top-actions mb-3">
      <li class="list-inline-item ">
        <input
          type="text"
          placeholder="{{ 'pages.newRetailer.search' | translate }}"
          matInput
          class="
            rounded-pill
            px-3
            py-2
            mb-0
            border-0
            bg-light
            w-100
            me-0
            input-search
            ms-3
          "
          (keyup)="quickSearch()"
          [(ngModel)]="searchValue"
        />
        <i
          color="primary"
          class="search-icon-holder"
          matSuffix
          mat-icon-button
          aria-label="Search"
        >
          <mat-icon>search</mat-icon>
        </i>
      </li>
      <li class="list-inline-item float-end">
        <button mat-stroked-button class="bg-theme ms-2" (click)="exportData()">
          <span translate class="translate">pages.newRetailer.download</span>
          <i class="mi mi-save-alt ms-2"></i>
        </button>
      </li>

      <li class="list-inline-item float-end">
        <button
          mat-stroked-button
          [disabled]="!showEditRetailer"
          class="bg-theme"
          (click)="editPricelist()"
        >
          {{ "pages.newRetailer.edit" | translate }}
          <i class="mi mi-drive-file-rename-outline"></i>
        </button>
      </li>

      <!--<li class="list-inline-item float-end me-2">
        <button
          mat-stroked-button
          [disabled]="!showEditRetailer"
          class="bg-theme  "
        >
        Filter by <i class="mi mi-drive-file-rename-outline"></i>
        </button>
      </li>    -->
    </ul>
    <ag-grid-angular
      style="width: 100%; height: 65vh"
      class="ag-theme-material"
      [rowHeight]="40"
      [enableFilter]="true"
      [enableSorting]="true"
      [enableColResize]="true"
      [rowSelection]="rowSelection"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
    >
    </ag-grid-angular>
  </div>
</ng-template>
